import { Filter as BaseFilter } from '@sketch/components'
import styled from 'styled-components'

const Search = styled(BaseFilter)`
  [type='search'] {
    box-shadow: none;
    border: 0;
    background-color: ${({ theme }) => theme.colors.background.tertiary.D};
  }

  [role='img'] {
    color: ${({ theme }) => theme.colors.background.primary.A};
  }
`

export default Search
